import { InputTypes } from "./form.types";

export enum FilterType {
  Contains = "contains",
  Equals = "equals",
  GreaterThan = "greaterThan",
  GreaterThanOrEqual = "greaterThanOrEqual",
  LessThan = "lessThan",
  LessThanOrEqual = "lessThanOrEqual",
  NotEquals = "notEquals",
  StartsWith = "startsWith",
  In = "in",
}

export type FilterValueTypes = InputTypes;

export type FilterValue = string | boolean | number;

export type FilterProperty<T> = keyof T | "all";

export interface IFilter<T> {
  property: FilterProperty<T>;
  filterType: FilterType;
  value: FilterValue;
  label?: string;
}

export type FilterAttributes = {
  defaultValue: FilterValue;
  type: FilterType;
  valueType: FilterValueTypes;
};
